import { Phone, MessageCircle, HelpCircle } from "lucide-react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../components/ui/accordion";

const FAQPage = () => {
  const phoneNumber = "05075537051";
  const whatsappNumber = "905075537051";
  const whatsappMessage = encodeURIComponent("Merhaba, eşya satmak istiyorum. Bilgi alabilir miyim?");
  const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${whatsappMessage}`;

  const faqCategories = [
    {
      title: "Eşya Satış Süreci",
      faqs: [
        {
          question: "Eşyamı nasıl satabilirim?",
          answer: `Eşyanızı satmak çok kolay! Sadece 3 adımda eşyanızı nakite çevirebilirsiniz:

1. **Fotoğraf Çekin**: Satmak istediğiniz eşyanın fotoğraflarını çekin. Marka, model ve genel durumunu gösteren birkaç açık fotoğraf yeterli olacaktır.

2. **WhatsApp'tan Gönderin**: 0507 553 70 51 numaralı WhatsApp hattımıza fotoğrafları gönderin. Eşyanın markası, modeli ve durumu hakkında kısa bir açıklama ekleyin.

3. **Teklif Alın ve Nakit Kazanın**: Uzman ekibimiz fotoğrafları inceleyip size en uygun fiyat teklifini sunar. Teklifi kabul ederseniz, size uygun bir zamanda adresinize gelir, eşyayı alır ve nakit ödemeyi anında yaparız.`,
        },
        {
          question: "Teklif almak için ne yapmalıyım?",
          answer: `Teklif almak için WhatsApp üzerinden bize ulaşmanız yeterli. 0507 553 70 51 numarasına eşyanızın fotoğraflarını gönderin. Fotoğraflarda eşyanın ön, arka ve yan görünümleri olsun. Marka, model ve varsa arıza durumunu belirtin. Uzman ekibimiz fotoğrafları inceleyip 10-15 dakika içinde size fiyat teklifi sunar.`,
        },
        {
          question: "Eşyamı ne kadar sürede alırsınız?",
          answer: `Teklifi kabul ettiğinizde, çoğu durumda aynı gün içinde eşyanızı almaya geliyoruz. Size uygun bir randevu saati belirlenir ve ekibimiz belirtilen saatte adresinize gelir. İstanbul genelinde 7/24 hizmet veriyoruz.`,
        },
        {
          question: "Eşyamı taşımak zorunda mıyım?",
          answer: `Hayır, eşyanızı taşımanıza gerek yok! Ekibimiz adresinize gelir ve eşyayı yerinden alır. Buzdolabı, çamaşır makinesi gibi ağır eşyalar için de endişelenmenize gerek yok. Profesyonel ekibimiz güvenli bir şekilde eşyayı taşır.`,
        },
      ],
    },
    {
      title: "Satın Alınan Eşyalar",
      faqs: [
        {
          question: "Hangi eşyaları satın alıyorsunuz?",
          answer: `Geniş bir ürün yelpazesinde alım yapıyoruz:

**Beyaz Eşyalar:**
- Buzdolabı (tek kapı, çift kapı, no-frost)
- Çamaşır Makinesi
- Bulaşık Makinesi
- Kurutma Makinesi
- Ankastre Set (fırın, ocak, davlumbaz)
- Derin Dondurucu

**Televizyonlar:**
- LED TV, LCD TV
- Smart TV, QLED TV
- Android TV, OLED TV
- Tüm marka ve boyutlar (32" - 85")

**Klimalar:**
- Split Klima
- Salon Tipi Klima
- İnverter Klima

**Ev Elektroniği:**
- Ses sistemleri
- Oyun konsolları
- Akıllı ev cihazları
- Elektrikli süpürge`,
        },
        {
          question: "Defolu veya arızalı eşya alıyor musunuz?",
          answer: `Evet! Sıfır, ikinci el, defolu ve hatta arızalı eşyaları da değerlendiriyoruz. Eşyanızın durumu ne olursa olsun bize ulaşabilirsiniz. Kozmetik hasarlı, çizik, hafif arızalı ürünler için de uygun fiyat teklifi sunuyoruz. Arızalı eşyalar için duruma göre değerlendirme yapılır.`,
        },
        {
          question: "Hangi markaları alıyorsunuz?",
          answer: `Tüm markaları değerlendiriyoruz! Samsung, LG, Sony, Arçelik, Beko, Vestel, Philips, Bosch, Siemens, Profilo, Toshiba, Panasonic, TCL, Hisense, Sharp, Grundig, Altus, Regal, SEG ve diğer tüm markalar. Yerli veya ithal fark etmeksizin her marka değerlendirilir.`,
        },
        {
          question: "Eski model eşyalar için de teklif alabilir miyim?",
          answer: `Evet, eski model eşyalar için de teklif verebiliyoruz. Model yılı ne olursa olsun, çalışır durumda olan tüm eşyalar değerlendirilir. Eski modeller için fiyat, eşyanın genel durumuna ve piyasa değerine göre belirlenir.`,
        },
      ],
    },
    {
      title: "Ödeme ve Fiyatlandırma",
      faqs: [
        {
          question: "Ödeme nasıl yapılıyor?",
          answer: `Ödeme tamamen nakit olarak yapılmaktadır. Eşyanızı adresinizden aldığımızda, anında nakit ödeme gerçekleştiriyoruz. Banka havalesi veya diğer ödeme yöntemleri tercih edilmez, güvenli ve hızlı nakit ödeme garantisi sunuyoruz.`,
        },
        {
          question: "Fiyatlandırma nasıl yapılıyor?",
          answer: `Fiyatlandırma, eşyanın markası, modeli, yaşı ve genel durumuna göre yapılır. Piyasa değerleri göz önünde bulundurularak adil fiyat teklifi sunuyoruz. Fotoğrafları inceledikten sonra size bir fiyat aralığı belirlenir. Yerinde ekspertiz sonrası kesin fiyat netleşir.`,
        },
        {
          question: "Teklif edilen fiyatı kabul etmek zorunda mıyım?",
          answer: `Hayır, kesinlikle zorunda değilsiniz. Size sunulan teklif tamamen ücretsiz ve bağlayıcı değildir. Teklifi beğenmezseniz herhangi bir ücret ödemeden vazgeçebilirsiniz. Pazarlık yapma imkanınız da vardır.`,
        },
        {
          question: "Birden fazla eşya için toplu fiyat alabilir miyim?",
          answer: `Evet, birden fazla eşya için toplu alım yapıyoruz ve toplu satışlarda daha avantajlı fiyatlar sunabiliriz. Ev taşıma, tadilat gibi durumlarda tüm eşyalarınız için tek seferde teklif alabilirsiniz.`,
        },
      ],
    },
    {
      title: "WhatsApp ve İletişim",
      faqs: [
        {
          question: "WhatsApp'tan nasıl ulaşabilirim?",
          answer: `WhatsApp üzerinden bize ulaşmak çok kolay:

1. 0507 553 70 51 numarasını telefonunuza kaydedin
2. WhatsApp'ı açın ve bu numaraya mesaj gönderin
3. Eşyanızın fotoğraflarını ekleyin
4. Marka, model ve durum hakkında kısa bilgi verin

Veya sitemizden yeşil WhatsApp butonuna tıklayarak doğrudan sohbet başlatabilirsiniz. 7/24 aktif olarak mesajlarınızı yanıtlıyoruz.`,
        },
        {
          question: "Fotoğraf gönderirken nelere dikkat etmeliyim?",
          answer: `İyi bir teklif almak için:
- Eşyanın ön, arka ve yan görünümlerini çekin
- Varsa hasarlı bölgelerin yakın çekimini alın
- Marka ve model etiketini görünür şekilde çekin
- Aydınlık ortamda net fotoğraflar çekin
- Eşyanın genel durumunu gösteren geniş açı bir fotoğraf ekleyin`,
        },
        {
          question: "Mesajıma ne kadar sürede yanıt alırım?",
          answer: `WhatsApp mesajlarınıza genellikle 5-15 dakika içinde yanıt veriyoruz. Yoğun saatlerde bu süre biraz uzayabilir ancak en geç 1 saat içinde mutlaka dönüş yapıyoruz. 7/24 aktif olarak hizmet veriyoruz.`,
        },
      ],
    },
    {
      title: "Hizmet Bölgeleri",
      faqs: [
        {
          question: "Hangi bölgelere hizmet veriyorsunuz?",
          answer: `İstanbul'un tüm ilçelerine hizmet veriyoruz. Avrupa ve Anadolu yakasının her noktasına ulaşıyoruz. Kadıköy, Üsküdar, Beşiktaş, Şişli, Bakırköy, Beylikdüzü, Ataşehir, Maltepe, Pendik, Kartal, Fatih, Beyoğlu, Sarıyer, Başakşehir, Esenyurt ve diğer tüm ilçelerde hizmet mevcuttur.`,
        },
        {
          question: "İstanbul dışına da hizmet veriyor musunuz?",
          answer: `Şu anda sadece İstanbul genelinde hizmet vermekteyiz. İstanbul dışındaki talepler için maalesef hizmet sağlayamıyoruz. Ancak İstanbul sınırları içindeki her noktaya 7/24 ulaşabiliyoruz.`,
        },
        {
          question: "Adrese geliş için ücret alıyor musunuz?",
          answer: `Hayır, İstanbul genelinde adrese geliş tamamen ücretsizdir. Eşyayı almaya geldiğimizde herhangi bir nakliye veya servis ücreti talep etmiyoruz. Sadece teklifi kabul ettiğinizde eşyayı alıyoruz, teklifi kabul etmezseniz herhangi bir ücret ödemiyorsunuz.`,
        },
      ],
    },
  ];

  return (
    <div data-testid="faq-page">
      {/* Hero Section */}
      <section className="bg-slate-50 py-16 md:py-24" data-testid="faq-hero">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl">
            <p className="text-[#002FA7] font-semibold text-sm uppercase tracking-widest mb-3">
              SIK SORULAN SORULAR
            </p>
            <h1 className="text-4xl md:text-5xl font-bold text-slate-900 tracking-tight mb-6">
              Merak Ettikleriniz
            </h1>
            <p className="text-lg text-slate-600 leading-relaxed">
              Eşya satış süreci, ödeme yöntemleri ve hizmetlerimiz hakkında en çok sorulan soruların yanıtlarını burada bulabilirsiniz.
            </p>
          </div>
        </div>
      </section>

      {/* Quick Contact */}
      <section className="py-8 border-b border-slate-200" data-testid="faq-quick-contact">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4 bg-blue-50 rounded-xl p-6">
            <div className="flex items-center gap-3">
              <HelpCircle className="w-8 h-8 text-[#002FA7]" />
              <div>
                <p className="font-semibold text-slate-900">Sorunuz mu var?</p>
                <p className="text-sm text-slate-600">Aradığınızı bulamadıysanız bize ulaşın</p>
              </div>
            </div>
            <div className="flex gap-3">
              <a
                href={`tel:${phoneNumber}`}
                className="cta-primary text-sm"
                data-testid="faq-phone-btn"
              >
                <Phone className="w-4 h-4" />
                <span>Ara</span>
              </a>
              <a
                href={whatsappUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="cta-whatsapp text-sm"
                data-testid="faq-whatsapp-btn"
              >
                <MessageCircle className="w-4 h-4" />
                <span>WhatsApp</span>
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Accordion */}
      <section className="py-16 md:py-24" data-testid="faq-content">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="space-y-12">
            {faqCategories.map((category, categoryIndex) => (
              <div key={categoryIndex} data-testid={`faq-category-${categoryIndex}`}>
                <h2 className="text-2xl font-bold text-slate-900 mb-6">{category.title}</h2>
                <Accordion type="single" collapsible className="space-y-4">
                  {category.faqs.map((faq, faqIndex) => (
                    <AccordionItem
                      key={faqIndex}
                      value={`${categoryIndex}-${faqIndex}`}
                      className="bg-white border border-slate-200 rounded-lg px-6 data-[state=open]:shadow-md"
                      data-testid={`faq-item-${categoryIndex}-${faqIndex}`}
                    >
                      <AccordionTrigger className="text-left font-semibold text-slate-900 hover:text-[#002FA7] py-4">
                        {faq.question}
                      </AccordionTrigger>
                      <AccordionContent className="text-slate-600 pb-4 whitespace-pre-line leading-relaxed">
                        {faq.answer}
                      </AccordionContent>
                    </AccordionItem>
                  ))}
                </Accordion>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 md:py-24 bg-[#002FA7]" data-testid="faq-cta">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-white tracking-tight mb-4">
            Başka Sorunuz mu Var?
          </h2>
          <p className="text-blue-100 text-lg mb-8">
            7/24 aktif WhatsApp hattımızdan bize ulaşın, tüm sorularınızı yanıtlayalım.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href={`tel:${phoneNumber}`}
              className="inline-flex items-center justify-center gap-2 bg-white text-[#002FA7] px-6 py-3.5 rounded-lg font-semibold hover:bg-slate-100 transition-colors"
              data-testid="faq-cta-phone-btn"
            >
              <Phone className="w-5 h-5" />
              <span>0507 553 70 51</span>
            </a>
            <a
              href={whatsappUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center gap-2 bg-[#25D366] text-white px-6 py-3.5 rounded-lg font-semibold hover:bg-[#128C7E] transition-colors"
              data-testid="faq-cta-whatsapp-btn"
            >
              <MessageCircle className="w-5 h-5" />
              <span>WhatsApp'tan Yaz</span>
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default FAQPage;
